import React, { useState, useContext } from "react";
import ProviderService from "../../../../../services/api/provider.service";
import moment from 'moment'
import Utilities from "../../../../../services/commonservice/utilities";
import { store } from "../../../../../context/StateProvider";
import Module from "../../../../templates/components/Module";
import Table2 from "../../../../templates/components/Table2";
import HPTDatePicker from "../../../../templates/components/HPTDatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import HPTSelect from "../../../../templates/components/HPTSelect";

const NoShow = (props) => {
    const [noShowData, setNoShowData] = useState();
    const [isLoader, setIsLoader] = useState(false)
    const [startDate, setStartDate] = useState(moment().startOf("D"));
    const [endDate, setEndDate] = useState(moment().endOf("D"));
    const state = useContext(store).state
    const [initialMessage, setInitialMessage] = useState(true)
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)
    const [cancelType, setCancelType] = useState(1)

    const cancelTypeList = [
        { value: 1, label: 'Cancelled' },
        { value: 2, label: 'No Show' },
      ];

    const getNoShow = () => {
        setInitialMessage(false);
        setIsLoader(true)
        var reqObj = {
            FromDate: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
            ToDate: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
        }
        if (cancelType) reqObj.CancelType = cancelType
        if (locationId) reqObj.LocationIds = locationId
        ProviderService.getNoShow(reqObj).then(data => {
            setNoShowData(data);
            setIsLoader(false)
        }).catch(console.log);
    }


    const columns = [
        {
            id: "fromDate",
            Header: "Date",
            accessor: (row) => {
                return row.fromDate ? moment(row.fromDate).format("MM-DD-YYYY") : ""
            }
        },
        {
            id: "time",
            Header: "Time",
            accessor: (row) => {
                return row.fromDate ? `${moment(row.fromDate).format('h:mm')}-${moment(row.toDate).format('h:mm A')}` : ""
            }
        },
        {
            id: "patientName",
            Header: "Client",
            accessor: record => record.patientName
        },
        {
            id: "patientPhone",
            Header: "Mobile Phone",
            accessor: (patient) => Utilities.toPhoneNumber(patient.patientPhone)
        },
        {
            id: "practiceServiceType",
            Header: "Service",
            accessor: record => record.practiceServiceType
        },
        {
            id: "doctorName",
            Header: "Provider",
            accessor: record => record.doctorName
        },
        {
            id: "cancelledTypeId",
            Header: "Cancellation Status",
            accessor: record => {
                const cancellationTypeOption = cancelTypeList.find(option => option.value === record.cancelledTypeId);
                return cancellationTypeOption?.label ?? "";
              }
        }
    ]

    const handleCancelTypeChange = (option) => {
        setCancelType(option ? option.value : null);
    };

    return (
        <>
        {isLoader &&
            <DimLoader loadMessage="Processing" />
        }
        <div className="row d-flex g-3">
            <div className='col-12 m-p-0'>
                    <Module title="Filters">
                        <div className='row d-flex'>
                            <div className='col-12 row d-flex justify-content-center mx-0 align-items-end report-filters'>
                                <HPTDatePicker setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                                <div className='col-md-auto col-12'>
                                    <div className='ui field'>
                                        <label>Cancellation Type</label>
                                        <HPTSelect
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            value={cancelType === null ? null : cancelTypeList.find(option => option.value === cancelType)}
                                            onChange={handleCancelTypeChange}
                                            options={cancelTypeList}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); getNoShow() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                            </div>
                        </div>
                    </Module>
            </div>
            <div className="col-12 m-p-0">
                <Module title="No Show Report">
                    <Table2
                        export
                        searchable
                        data={noShowData}
                        columns={columns}
                        loading={false}
                        title='No Show Report'
                        initialMessage={initialMessage}
                    />
                </Module>
            </div>
        </div>
        </>
        )
}

export default NoShow;